'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _importExport = require('./import-export.service');

var _importExport2 = _interopRequireDefault(_importExport);

var _importDialog = require('./import-dialog.controller');

var _importDialog2 = _interopRequireDefault(_importDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.importexport', []).factory('importExport', _importExport2.default).controller('ImportDialogController', _importDialog2.default).name;


// WEBPACK FOOTER //
// ./src/app/import-export/index.js